import React, {useEffect, useState} from "react";
import {useAppSelector} from "../../../../../redux/store";
import BarekamRadio from "../../../../components/radio";
import BarekamText from "../../../../components/text";
import {GapContainer} from "../../../../components/card/styled";
import {StandardDialogFooter} from "../../../../components/dialogs/standard-dialog/standard-dialog";
import Message from "../../../../components/message";
import {MessageSections} from "../../../../components/message/message";
import {Recipient} from "../../../../shared/models/user/recipient/recipient";
import recipientService from "../../../../../services/recipient.service";
import {Alert, DialogContent} from "@mui/material";
import {AxiosError} from "axios";
import {mapValidationErrors} from "../../personal-info/personal-info.service";

export const EditDefaultRecipient = ({onClose}: EditDefaultRecipientProps) => {
    const [defaultRecipientId, setDefaultRecipientId] = useState<number>();
    const {myRecipientsData} = useAppSelector(state => state.recipientDataReducer);

    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    useEffect(() => {
        setDefaultRecipientId(myRecipientsData.recipients.find(recipient => recipient.isDefault)?.recipientId)
    }, [])

    async function handleClose() {
        if (defaultRecipientId) {
            const oldDefaultRecipient = myRecipientsData.recipients.find(recipient => recipient.isDefault) || {} as any;

            if (oldDefaultRecipient.recipientId !== defaultRecipientId) {
                return recipientService.changeDefaultRecipient(defaultRecipientId)
                    .then(response => {
                        if (response.acknowledged) {
                            onClose(true);
                        }
                    })
                    .catch(e => {
                        if (e instanceof AxiosError) {
                            setErrors(mapValidationErrors(e));
                        }
                    });
            } else {
                onClose(false);
            }
        } else {
            onClose(false);
        }
    }

    const RecipientRow = ({recipient}: {recipient: Recipient}) => {
        return (
            <GapContainer onClick={() => setDefaultRecipientId(recipient.recipientId)}
                          style={{cursor: 'pointer'}}>
                <BarekamRadio checked={recipient.recipientId === defaultRecipientId}/>

                <BarekamText variant={"s"}>
                    {recipient.firstName}
                    {' '}
                    {recipient.lastName}
                </BarekamText>
            </GapContainer>
        )
    }

    return (
        <>
            <DialogContent>
                {myRecipientsData.recipients.map(recipient =>
                    <RecipientRow recipient={recipient} key={recipient.recipientId}/>
                )}

                {Object.keys(errors).length
                    ? Object.keys(errors).map((errorKey, index) =>
                        <Alert severity="error" key={index}>
                            <Message messageKey={errors[errorKey]} sectionId={MessageSections.USER}/>
                        </Alert>
                    )
                    : ''
                }
            </DialogContent>

            <StandardDialogFooter saveLabel={<Message messageKey={'save'} sectionId={MessageSections.USER}/>}
                                  onSave={() => handleClose()}
                                  onCancel={() => onClose(false)}/>
        </>
    )
}

interface EditDefaultRecipientProps {
    onClose: (withChange: boolean) => void,
}